@if (isDetailsViewAvailable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onClick($event)"
    id="afterSalesOverviewDetailBtn"
    ui-test-id="afterSalesOverviewDetailBtn"
    icon="search"
    style="float: left"
    size="small"></pas-button-round>
}
